import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
 * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* text-transform: uppercase; */
  font-family: "GT America, bold";
  font-family: "GT America, boldN";
  touch-action: manipulation;
  scrollbar-width: none;

}
*:not(input) {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
 
html,
body,
#root {  
 height: 100%;
  position: relative;
}

 
html,
body,
#root {
   height: 100%;
}
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: none;
  -webkit-box-shadow: none;
  background-color: transparent;
}
body > div {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -webkit-overflow-scrolling: touch;
}
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffb000;
   touch-action: manipulation;
  scrollbar-width: none;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
 }

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: 3px solid #ffbb00;
  color: #ffb000;
  -webkit-text-fill-color: #ffb000;
   transition: background-color 5000s ease-in-out 0s;
  background: transparent;
}



input {
  outline: none;
}
 

`
